import React from "react";
import { useParams } from "react-router-dom";
import "./courtsPage.css";
import { facilities } from "./AboutPage";

const CourtsPage = () => {
  const { name } = useParams();

  const selectedCourt = facilities.find(
    (item) => item.slug.toLowerCase() === name.toLowerCase()
  );

  if (!selectedCourt) {
    return <div className="courtpage-notfound">Court Not Found!</div>;
  }

  return (
    <div className="courtpage-wrapper">
      <section
        className="courtpage-banner"
        style={{
          backgroundImage: `url(${selectedCourt.image})`,
        }}
      >
        <div className="courtpage-overlay">
          <h1 className="courtpage-title">{selectedCourt.name}</h1>
        </div>
      </section>

      <div className="courtpage-content">
        <h2 className="courtpage-heading">About {selectedCourt.name}</h2>
        <p className="courtpage-description">{selectedCourt.description}</p>
      </div>
    </div>
  );
};

export default CourtsPage;
